import React, { useEffect, useMemo, useState } from 'react';
import api from '../lib/api';
import PageRenderer from '../components/PageRenderer';
import usePageMeta from '../hooks/usePageMeta';

export default function LandingPage() {
  const [page, setPage] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get('/api/pages/home')
      .then(({ data }) => setPage(data))
      .catch((e) => setErr(e.message));
  }, []);

  // Derive SEO data from page + first hero block (fallbacks for image/description).
  const seo = useMemo(() => {
    if (!page) return { title: 'Welcome' };
    const blocks = page.blocks || [];
    const hero = blocks.find((b) => b?.type === 'section_hero') || {};
    const description =
      page.meta_description ||
      hero.subtitle ||
      'Discover The Elemental Embrace — a guided journey with EE, your conversational companion, and the book that grounds it all.';
    const image = page.meta_image || hero.image_src || undefined;
    return {
      title: page.meta_title || page.title || 'Welcome',
      description,
      image,
    };
  }, [page]);

  usePageMeta(seo);

  if (err) return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="text-gold text-xl mb-2">Unable to load page</div>
        <div className="text-ee-muted text-sm">{err}</div>
      </div>
    </div>
  );

  if (!page) return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="h-10 w-10 rounded-full border-2 border-gold/30 border-t-gold animate-spin" />
    </div>
  );

  return <PageRenderer blocks={page.blocks || []} />;
}
